export const getSaleTagList = state => {
    return state.list
}

export const getSaleTagDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/saleTag/getters.js